import { render, staticRenderFns } from "./ModalIndividualStatistic.vue?vue&type=template&id=3377a812&lang=pug&"
import script from "./ModalIndividualStatistic.vue?vue&type=script&lang=js&"
export * from "./ModalIndividualStatistic.vue?vue&type=script&lang=js&"
import style0 from "./ModalIndividualStatistic.vue?vue&type=style&index=0&id=3377a812&prod&lang=sass&"
import style1 from "./ModalIndividualStatistic.vue?vue&type=style&index=1&id=3377a812&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports